import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PlaceNode, PlacesApi } from '@ulysses-inc/harami_api_client'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import {
  handleHTTPError,
  isHTTPError,
} from 'src/state/middleware/saga/handleHttpError'
import { placeGroupQueryKeys } from './queryKeys'

export type AddPlaceGroupParams = {
  placeNode: PlaceNode
}

export const useMutationAddPlaceGroup = () => {
  const queryClient = useQueryClient()
  const { showErrorSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: async (params: AddPlaceGroupParams) => {
      return await baseClient
        .getApi(PlacesApi)
        .addPlaceGroup({ placeNode: params.placeNode })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: placeGroupQueryKeys.all })
    },
    onError: (error: unknown) => {
      if (isHTTPError(error)) {
        showErrorSnackbar(error.errors.join('\n'))
      } else {
        showErrorSnackbar('現場グループの追加に失敗しました')
      }
    },
  })
}
